export class NavigationConstants {

    static MOD_STOCK_SCREENER = 'FIVE_FOUR_TWO';
    static MOD_ETF_SCREENER = 'FIVE_THREE_FIVE';
    static MOD_MUTUAL_FUND_SCREENER = 'FIVE_FOUR_THREE';
    static propertyMap = new Map([
    [ 'davenport' , new Map([['Advisor' , 'NXI_NAVIGATION.ADVISORHOMEDAV']])],
    [ 'troweprice' , new Map([['Advisor' , 'NXI_NAVIGATION.ADVISORHOMETROWE']])],
    [ 'tradelink' , new Map([['Advisor' , 'NXI_NAVIGATION.ADVISORHOMETROWE']])],
    [ 'btgpactual' , new Map([['Advisor' , 'NXI_NAVIGATION.ADVISOR']])],
    [ 'bmodirect' , new Map([['Advisor' , 'NXI_NAVIGATION.ADVISORHOMEBMO'], ['showIcon' , 'true']])]
    ]);
}
